import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import './check-box.css';

export class CheckBox extends Component {
  static propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChecked: PropTypes.func,
    handleChange: PropTypes.func,
    value: PropTypes.number
  }
  constructor(props) {
    super(props);

    this.id = uuidv4();

    // this.setChecked = this._setChecked;

    const { name, value, checked } = this.props;

    this.state = {
      id: this.id,
      name: name,
      checked: checked,
      value: value
    };
  }

  // componentDidMount() {

  // this.setState({
  //   name: this.props.name,
  //   checked: this.props.checked,
  //   value: this.props.value
  // });

  // $('#' + this.id).bind('click', this.onChecked.bind(this));
  // if (this.props.checked) {
  //   $('#' + this.id).prop('checked', true);
  // }

  // }

  // componentWillReceiveProps(nextProps) {

  // if (nextProps.isRebind) {
  //   this.setState({ name: nextProps.name, checked: nextProps.checked, value: this.props.value });

  //   if (nextProps.checked === true || nextProps.checked === 'true') {
  //     $('#' + this.id).prop('checked', true);
  //   } else {
  //     $('#' + this.id).prop('checked', false);
  //   }
  // }

  // }

  // componentWillUnmount() {
  //  $('#' + this.id).unbind('click', this.onChecked.bind(this));
  // }

  // _setChecked(isChecked) {
  //   $('#' + this.id).prop('checked', isChecked);
  // }

  // getValuesChecked(e) {
  //   var values = [];

  //   if (!$(e.target).hasClass('checkbox')) {
  //     $('input[name=\'' + this.props.name + '\']').map((i, ckb) => {
  //       if ($(ckb).is(':checked')) {
  //         values.push($(ckb).val());
  //       }
  //     });
  //   }

  //   return values;
  // }

  // onChecked(e) {

  //   this.setState({ name: $(e.target).attr('name'), checked: $(e.target).is(':checked'), value: $(e.target).val() });

  //   let values = this.getValuesChecked(e);

  //   if (typeof (this.props.onChecked) !== 'undefined') {
  //     if (values.length === 0) {this.props.onChecked(e, '', this.state);}
  //     else if (values.length === 0) {this.props.onChecked(e, values[0], this.state);}
  //     else {this.props.onChecked(e, values, this.state);}
  //   }

  // }

  onToggleClick = (e) => {
    this.setState({
      checked: !this.state.checked
    });
    this.props.handleChange(e, this.props.value);
  }

  render() {
    return <div itemID={this.state.id} className={`checkbox ${this.props.className}`} style={{zIndex: 9999}}>
      <input
        id={this.state.id}
        name={this.state.name}
        className='s1-ckb'
        type='checkbox'
        value={this.props.value}
        checked={this.props.checked}
        onClick={this.onToggleClick} />
      <label htmlFor={this.state.id}> {this.props.label}</label>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/checkboxes/check-box.js